import React from 'react';
import { Skeleton } from '@yme/common/components/skeletons';
export function CardPanelSkeleton() {
    return (React.createElement(React.Fragment, null,
        React.createElement(Skeleton, { skeletonProps: {
                width: 100,
                height: 16,
            }, wrapperProps: {
                mbS: 8,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                width: 36,
                height: 36,
                count: 3,
                inline: true,
                circle: true,
                style: {
                    marginRight: '8px',
                },
            }, wrapperProps: {
                mbS: 32,
                mbL: 24,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 60,
            }, wrapperProps: {
                mbS: 24,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 24,
                width: '50%',
            }, wrapperProps: {
                mbS: 24,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 48,
            }, wrapperProps: {
                mbS: 24,
                mbL: 40,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 28,
            } })));
}
